module.exports = __webpack_public_path__ + "static/media/icon_exclamation_circle.47c4a0c3.svg";